// extracted by mini-css-extract-plugin
module.exports = {"image":"style_image__k4k6Y"};